import webComponentsConfiguration from '@mg/web-components/webComponentsConfigurationPlugin'
import Vue from 'vue'
import { CONFIG_KEY } from '@mg/micro/vue2'
import { getAlternativePrice } from '~/utils/alternativePrice'
import LazyComponent from '~/components/LazyComponent.vue'

export default (context: any) => {
  const alternativePrice = getAlternativePrice(context)

  const config = {
    cdnUrl: context.app.$env!.cdnUrl,
    isNuxtClientOnly: true,
    isNuxtRouterEnabled: true,
    lazyLoadingEnabled: true,
    ...(alternativePrice && { alternativePrice }),
  }

  // Call the plugin's install function directly instead of via Vue.use().
  // webComponentsConfiguration(config) returns a new closure on every
  // request, so Vue.use() would push it into Vue._installedPlugins every
  // time (identity check never matches) — an unbounded memory leak in a
  // long-running SSR process. Calling it directly avoids that, while still
  // recomputing the *full* $webComponentsConfiguration object (with all its
  // defaults) on every request, so state never leaks between requests/users.
  // VueLazyload itself is still installed only once, because Vue.use(VueLazyload, ...)
  // inside the plugin dedupes on the stable VueLazyload import reference.
  webComponentsConfiguration(config)(Vue)

  // `@mg/web-components` enables `vue-lazyload`'s `lazyComponent`, which globally
  // registers a `<lazy-component>` that collides with our own
  // `~/components/LazyComponent.vue`. On some pages (e.g. product detail) the
  // vue-lazyload component shadows ours, so lazy sections stay stuck on their
  // skeleton and never render. Re-register our component under the same tag so
  // `<lazy-component>` always resolves to ours across SSR and client.
  Vue.component('lazy-component', LazyComponent)

  // Provide CONFIG_KEY for @mg/micro components
  context.app.provide = context.app.provide || {}
  // `InjectionKey<T>` is a TS-only interface type (not an actual runtime
  // `symbol`), so it isn't structurally assignable to the `PropertyKey`
  // (`string | number | symbol`) that Object.defineProperty expects. The
  // key IS a real symbol at runtime — cast through `unknown` to satisfy TS.
  Object.defineProperty(context.app.provide, CONFIG_KEY as unknown as symbol, {
    get: () => Vue.prototype.$webComponentsConfiguration ?? {},
    enumerable: true,
  })
}
